import {
  AutoStoriesOutlined as ReadIcon,
  WorkOutline as WorkIcon,
  GroupOutlined as GroupIcon,
  HelpOutline,
} from "@mui/icons-material";

const ICON_MAP = {
  // Tenant Types
  students: ReadIcon,
  professionals: WorkIcon,
  both: GroupIcon,
};

export const TenantOutlinedIcon = ({ iconKey, ...props }) => {
  const IconComponent = ICON_MAP[iconKey] || HelpOutline;
  return <IconComponent fontSize="inherit" {...props} />;
};
